// @flow

const billingContentStyles = {
  billingContentContainer: (theme) => ({
    flexGrow: 1,
    marginTop: theme.layout.customProps.header.height, // Position below single-row header
    padding: theme.spacing(3),
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2)
    }
  }),
  cardCtr: (theme) => ({
    marginTop: theme.spacing(2),
    maxWidth: 700,
    borderRadius: 0,
    padding: `${theme.spacing(1)}px ${theme.spacing(3)}px ${theme.spacing(3)}px ${theme.spacing(3)}px`
  }),
  normal: (theme) => ({
    fontWeight: 400
  }),
  downloadLink: (theme) => ({
    color: theme.palette.primary.dark
  }),
  addCardCancel: (theme) => ({
    position: 'relative',
    textDecoration: 'none',
    color: 'black',
    fontSize: '0.8rem',
    marginLeft: 10,
    top: 4
  }),
  sectionTitleLegend: (theme) => ({
    marginTop: -theme.spacing(1.5),
    color: theme.palette.custom.backgroundTextInfo
  }),
  topupTable: (theme) => ({
    // tableLayout: 'fixed',
    marginTop: theme.spacing(2),
    width: '100%',
    overflow: 'scroll'
  }),
  col1: (theme) => ({
    minWidth: 100
  }),
  col2: (theme) => ({
    minWidth: 100
  }),
  col3: (theme) => ({
    minWidth: 160
  }),
  col4: (theme) => ({
    minWidth: 100
  }),
  col5: (theme) => ({
    textAlign: 'right'
  }),
  priceCell: (theme) => ({
    fontSize: '1rem',
    fontWeight: '600',
    color: theme.palette.primary.main
  }),
  tableHeadRowCtr: (theme) => ({
    '& th': {
      paddingBottom: theme.spacing(0.5),
      fontSize: '0.9rem',
      color: 'hsl(0,0%,50%)',
      fontWeight: 400
    }
  }),
  topupDetails: (theme) => ({
    color: theme.palette.custom.backgroundTextInfo
  }),
  textBold: (theme) => ({
    '& th': {
      fontWeight: 600
    }
  }),
  usageTable: (theme) => ({
    display: 'table !important',
    '& th:first-of-type, & td:first-of-type': {
      paddingLeft: theme.spacing(4)
    },
    '& th:last-of-type, & td:last-of-type': {
      paddingRight: theme.spacing(4)
    }
  }),
  highlightCredits: (theme) => ({
    fontSize: '1.4rem'
  }),
  defaultChip: (theme) => ({
    color: 'black'
  }),
  link: (theme) => ({
    textDecoration: 'underline',
    cursor: 'pointer'
  }),
  content: (theme) => ({
    flexGrow: 1,
    padding: `${theme.spacing(1)}px ${theme.spacing(3)}px ${theme.spacing(3)}px ${theme.spacing(3)}px`
  })
};

export default billingContentStyles;